import React from 'react';

import RIQSparkLine from '../../../components/RIQSparkLine.jsx';

import {
    DeltaRelativeInsight,
    NumericalValue,
    Summary
} from '../../../components/Summary.jsx';

import {
    listeningDefinitions
} from './enums/listeningDefinitions.jsx';

function DeltaRelativeSummaryInsight({request, result}) {
    const value = result.data[0][0];
    const formatted = RivalIQ.metrics.new.MetricFormatter.getFormattedResults(request, result, RivalIQ.metrics.new.enums.MetricFormatTypes.abbreviated);

    return (
        <DeltaRelativeInsight
            formatted={formatted}
            value={value}/>
    );
}

export default function SingleGlanceMetricDisplay({metricRequest, metricResult, metricName, deltaRelativeRequest, deltaRelativeResult, renderSparkLine, metricResultForSparkLine, metricClasses, description}) {

    metricName = metricName || RivalIQ.metrics.new.MetricRegistry.getName(metricRequest, true) || '';

    description ??= listeningDefinitions.metrics[metricRequest.measure];

    let value = null;
    if (metricResult.error) {
        value = <h5>Error: {metricResult.error.message}</h5>;
    } else {
        let sparkLine = null;
        if (renderSparkLine && !metricResultForSparkLine.error) {
            sparkLine = (
                <RIQSparkLine
                    className='tlw-ml-3 tlw-flex tlw-h-18 tlw-items-end'
                    data={_.map(metricResultForSparkLine.data, (row, idx) => {
                        return {
                            id: idx,
                            value: _.last(row)
                        };
                    })}
                />
            );
        }

        const formattedValue = RivalIQ.metrics.new.MetricFormatter.getFormattedResults(metricRequest, metricResult, RivalIQ.metrics.new.enums.MetricFormatTypes.abbreviated);
        const expandedValue = RivalIQ.metrics.new.MetricFormatter.getFormattedResults(metricRequest, metricResult, RivalIQ.metrics.new.enums.MetricFormatTypes.expanded);

        value = (
            <div className='tlw-flex tlw-flex-row tlw-items-start'>
                <NumericalValue
                    className={metricClasses}
                    formatted={_.last(formattedValue)}
                    value={expandedValue} />
                {sparkLine}
            </div>
        );
    }

    let insight = null;
    if (deltaRelativeResult) {
        insight = (
            <DeltaRelativeSummaryInsight
                request={deltaRelativeRequest}
                result={deltaRelativeResult}
            />
        );
    }

    return (
        <Summary
            className='tlw-grow'
            description={description}
            insight={insight}
            title={metricName}
            value={value}
        />
    );
}
